export default "__VITE_ASSET__BM85vc8s__"